/**
 * Chawla Ispat ka EK HI NAP source (Name - Address - Phone).
 *
 * Local SEO ka sabse sasta factor = har jagah bilkul ek jaisa NAP: website,
 * Google Business Profile, IndiaMART, JustDial, ExportersIndia. Saara
 * LocalBusiness / Organization schema sirf yahin se banta hai — do jagah
 * address likhoge to Google dono par bharosa kam kar dega.
 *
 * TODO (owner): sirf godowns baaki. telephone / email / openingHours / geo
 * 21-Sep-2026 ko confirm ho gaye.
 * Abhi sirf wahi bhara hai jo pakka hai (public listings + repo ka WhatsApp
 * number). Khaali field schema me jaata hi nahi — galat data se khaali behtar.
 */

export type Godown = {
  name: string;
  street: string;
  locality: string;
  postalCode: string;
  telephone?: string;
  mapUrl?: string;
  geo?: { lat: number; lng: number };
};

export const BUSINESS = {
  legalName: "Chawla Ispat Private Limited",
  name: "Chawla Ispat",
  description:
    "Rudrapur ka building material bazaar - TMT bar, GC/GP sheet, pipe, cement aur hardware. Rate roz update, GST bill, godown se 1-2 din me delivery.",
  url: "https://chawlaispat.com",
  logo: "https://chawlaispat.com/logo512.png",
  gstin: "05AADCC0727A1ZH",
  cin: "U27107UR2007PTC032379",
  /** Owner ne confirm kiya (21-Sep-2026). Google Maps listing par bhi yahi
      number hona chahiye — abhi wahan 07500093000 laga hai. */
  telephone: "+918279638689",
  email: "chawla@chawlaispat.com",
  foundingDate: "2007",
  priceRange: "₹₹",
  currenciesAccepted: "INR",
  paymentAccepted: "Cash, UPI, Bank transfer, Dealer credit",
  areaServed: [
    "Rudrapur",
    "Pantnagar",
    "Kashipur",
    "Kichha",
    "Haldwani",
    "Udham Singh Nagar",
    "Uttarakhand",
  ],
  address: {
    // Google Maps listing se hu-ba-hu (NAP), shop number 41 ke saath.
    street: "41, Main Market - Galla Mandi Rd, Gandhi Colony",
    locality: "Rudrapur",
    region: "Uttarakhand",
    postalCode: "263153",
    country: "IN",
  },
  /** Google Maps listing se verified (21-Sep-2026). */
  geo: { lat: 28.9745691, lng: 79.3945123 } as null | { lat: number; lng: number },
  /** Mangalvaar-Ravivaar 8am-7pm, Somvaar band (owner, 21-Sep-2026). */
  openingHours: ["Tu-Su 08:00-19:00"] as string[],
  sameAs: [
    // Google Business Profile / Maps listing (cid = is listing ka pakka id).
    "https://maps.google.com/?cid=5857628351115194363",
    "https://play.google.com/store/apps/details?id=com.chawlaispat",
    "https://www.indiamart.com/chawla-ispat-private-limited/",
    "https://www.exportersindia.com/chawla-ispat-private-limited/",
    "https://lohawalla.com",
  ],
  /** TODO owner: 5 godown ke naam, address, pincode, map link. */
  godowns: [] as Godown[],
};

export const businessAddressText = (): string =>
  [
    BUSINESS.address.street,
    BUSINESS.address.locality,
    BUSINESS.address.region,
    BUSINESS.address.postalCode,
  ]
    .filter(Boolean)
    .join(", ");
